var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dashboard-tasks-list"},_vm._l((_vm.tasks),function(task){return _c('tasks-item',{key:task.id,attrs:{"task":task}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }